<template>
  <div>
    <page-head
      :title="title"
      :btn-list="btnList"
      :show-back="false"
      @handleBtn="handleBtn"
    ></page-head>
    <div class="content">
      <!-- <div class="search">
        <i-form ref="search" :model="query">
          <row :gutter="80">
            <i-col span="6">
              <form-item label="统一社会信用代码" prop="usc_code">
                <Input
                  v-model="query.usc_code"
                  clearable
                  placeholder="请输入统一社会信用代码"
                />
              </form-item>
            </i-col>
          </row>
        </i-form>
      </div> -->
      <div class="table-data">
        <div class="bottomtable">
          <i-table
            :columns="tableHeader"
            :border="true"
            :loading="isLoading"
            :data="info"
            stripe
            ref="table"
            height="500"
          >
            <template slot-scope="{ row, index }" slot="action"> </template>
          </i-table>
        </div>
      </div>
    </div>

    <!-- <div class="content" v-if="info">
        <div class="search">
          <Form>
            <row :gutter="80" v-for="itme in info">
              <i-col span="8" v-for="(data, key) in itme">
                <FormItem :label="key + ':'">
                  <div class="detail">{{ data }}</div>
                </FormItem>
              </i-col>
            </row>
          </Form>
        </div>
      </div> -->
  </div>
</template>
  
  <script>
import pageHead from "../../../components/head";
import api from "../../../api/index";
const { qyjjjfpjxx } = api;
export default {
  name: "marriageRegister",
  components: {
    pageHead,
  },

  data() {
    return {
      query: {
        // usc_code: "",
      },
      info: undefined,
      isLoading: false,
      tableHeader: [
        { title: "案号", key: "ah", align: "center" },
        { title: "立案案由", key: "laay", align: "center" },
        { title: "经办法院", key: "jbfy", align: "center" },
        { title: "地区", key: "dq", align: "center" },
        { title: "结案案由", key: "jaay", align: "center" },
        { title: "结案方式", key: "jafs", align: "center" },
        { title: "立案日期", key: "larq", align: "center" },
        { title: "结案日期", key: "jarq", align: "center" },
        { title: "结案标的额", key: "jabde", align: "center" },
        { title: "原告/上诉人", key: "ygssr", align: "center" },
        { title: "被告/被上诉人", key: "bgrbssr", align: "center" },
        { title: "企业名称", key: "qymc", align: "center" },
        { title: "企业证照代码", key: "qyzzdm", align: "center" },
        { title: "身份证号码", key: "sfzhm", align: "center" },
      ],
      title: "高院的判决信息",
      btnList: [
        // {
        //   name: "重置",
        //   type: "reset",
        // },
        {
          name: "查询",
          type: "search",
        },
      ],
    };
  },
  methods: {
    handleBtn(type) {
      if (type == "reset") {
        this.query.usc_code = "";
        this.query.entname = "";
        this.$refs.search.resetFields();
      } else if (type == "search") {
        this.marriageRegister();
      }
    },
    async marriageRegister() {
      // if (!this.query.usc_code) {
      //   return this.$Message.warning("请输入统一社会信用代码");
      // }
      this.isLoading = true;
      try {
        let data = {
          // usc_code: this.query.usc_code,
        };
        console.log(data);
        let res = await this.$get(qyjjjfpjxx, data);
        console.log(res);
        if (res) {
          this.info = res.rows;
        } else {
          this.info = undefined;
        }
      } finally {
        this.isLoading = false;
      }
      console.log(this.query);
    },
  },
  created() {},
  mounted() {
    this.marriageRegister();
  },
};
</script>
  
  <style lang="less" scoped>
.content {
  margin: 20px;
}

.search {
  width: 100%;
  background-color: white;
  border-radius: 5px;
  padding: 20px;
  margin-bottom: 20px;
}

.label {
  width: 100px;
}

.time {
  width: 100%;
}
</style>
  